export default "__VITE_ASSET__BkuLfVhq__"